module.exports = __webpack_public_path__ + "static/hero_1-425c68af52ffd0650915cc77ff157e6c.png";